import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { SVGPureIcon } from '@/ui';
import { request } from '@src/common';
import axios from 'axios';
import globalStore from '@/store/global';
import { HelpOther } from '@/common/helper';
import InfiniteScroll from 'react-infinite-scroll-component';
import { uploadToS3 } from '@/common/upload/upload-s3';
import { Spin } from 'antd';
import apiRobot from '@/common/apiRobot';
import homeStore from '@/pages/home/store';
import { Switch, Input, Divider, Upload, Card, Image } from 'antd';
import '../index.scss';
import store from '../store'

const PrivateForm = observer(() => {
  const [imgUrl, setImgurl] = useState(''); // 头像地址
  const [modelName, setModelName] = useState(''); // 模型名称
  const [apiUrl, setApiUrl] = useState(''); // API地址
  const [apiVersion, setApiVersion] = useState(''); // API版本
  const [secretKey, setSecretKey] = useState(''); // 密匙
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firmSwitch, setFirmSwitch] = useState(false); // 服务商开关
  const [isOllama, setIsOllama] = useState(false); // 是否是Ollama
  // 校验表单
  const validateForm = () => {
    const validations = [
      {
        value: apiUrl,
        message: '请输入API地址',
        required: true,
        validator: (value) => {
          if (!value) return false;
          const urlPattern = /^https?:\/\/.+/i;
          return urlPattern.test(value);
        },
        errorMessage: 'API地址必须以 http:// 或 https:// 开头'
      },
      {
        value: modelName,
        message: '请输入模型名称',
        required: isOllama ? false : true,
      },
      {
        value: apiVersion,
        message: '请输入API版本',
        required: store.activeModel?.protocol === 4 ? true : false,
      },
      // {
      //   value: secretKey,
      //   message: '请输入密钥',
      //   required: true,
      // }
    ];
    for (const validation of validations) {
      const { required, value, message, validator, errorMessage } = validation;
      if (required && !value) {
        HelpOther.toast(message, 'info');
        return false;
      }
      if (validator && !validator(value)) {
        HelpOther.toast(errorMessage, 'info');
        return false;
      }
    }
    return true;
  }
  const customModelInfo = async (params) => {
    try {
      const res = await request.post('/user/model/custom', params, {
        dataIsJson : true,
      })
      homeStore.setDirty();
      return res.code === 0;
    } catch (error) {
      HelpOther.toast('添加失败', 'error');
      return false;
    }
  }

  const updateURL = (url = '') => {
    if (!url) url = '/';
    if (store.activeModel?.protocol === 4) {
      if (!url.endsWith('/')) {
        url += '/'
      }
      return `${url}openai/deployments/${modelName}/chat/completions`;
    } else if (store.activeModel?.protocol === 1) {
      if (url.endsWith('#')) {
        return url.slice(0, -1);
      } else if (url.endsWith('/')) {
        return `${url}v1/chat/completions`;
      }
      return url;
    // } else if (store.activeModel?.protocol === 2) {
    //   if (!url.endsWith('/')) {
    //     url += '/'
    //   }
    //   return `${url}models/${modelName}`;
    }
    return url;
  };

  const updateTipsURL = (url) => {
    const u = updateURL(url);
    if (u.length <= 40) return u;
    return `${u.slice(0, 17)}...${u.slice(u.length - 20)}`;
  };

  const ollamaCheck = async (url) => {
    try {
      const res = await axios.get('http://127.0.0.1:11434/api/tags')
      let models = []
      if (res.status === 200) {
        models = res.data.models.map(item=> {
          return {
            id: '',
            summary: '',
            name: item.name,
            icon: '',
            enable: true,
            title: item.name,
            ext: { reasoning: false },
          }
        })
        const params = {
          ...store.activeModel,
          firm_id: store.activeModel?.id,
          is_preset: true,
          key: {
            api_key: secretKey,
          },
          api_url: url,
          enable: true,
          models,
        };
        if (models.length) {
          await apiRobot.checkAPIKey(secretKey, models[0].name, url, store.activeModel?.protocol)
          .then(async () => {
            HelpOther.toast('连接成功');
            setLoading(false);
            const success = await customModelInfo(params);
            if (success) {
              store.setActiveModel(params);
              store.setModelFirmList(params, true);
            }
          }).catch(() => {
            setLoading(false);
            HelpOther.toast('检测失败', 'error');
          })
        } else {
          HelpOther.toast('未检测到模型', 'error');
        }
      } else {
        HelpOther.toast('检测失败', 'error');
        setLoading(false);
      }
    } catch (error) {
      HelpOther.toast('检测失败', 'error');
      setLoading(false);
    }
  }

  const handleCheck = async () => {
    if (!validateForm()) return;
    setLoading(true);
    let url = updateURL(apiUrl);
    if (store.activeModel?.protocol === 4) {
      url += `?api-version=${apiVersion}`;
    }
    if (isOllama) {
      ollamaCheck(url);
      return
    }
    await apiRobot.checkAPIKey(secretKey, modelName, url, store.activeModel?.protocol)
    .then(async (reasoning) => {
      HelpOther.toast('连接成功');
      const ext = { reasoning };

      setLoading(false);
      const params = {
        firm_id: store.activeModel?.id,
        model_type: store.activeModel?.model_type,
        protocol: store.activeModel?.protocol,
        key: {
          api_key: secretKey,
        },
        api_url: url,
        enable: true,
        models: [
          {
            id: '',
            summary: '',
            name: modelName,
            icon: imgUrl,
            enable: true,
            title: modelName,
            ext,
          }
        ]
      };
      const success = await customModelInfo(params);
      if (success) {
        const newActiveModel = {
          ...store.activeModel,
          ...params,
          id: store.activeModel?.id,
          protocol: store.activeModel?.protocol,
          model_type: store.activeModel?.model_type,
          name: store.activeModel?.name,
        }
        store.setActiveModel(newActiveModel);
        store.setModelFirmList(newActiveModel);
      }
    }).catch(() => {
      setLoading(false);
      HelpOther.toast('连接失败', 'error');
    })
   
  }
  const handleUpload = ({ file }) => {
    const { type } = file;
    if (!/^image/.test(type)) {
      HelpOther.toast('请上传图片文件', 'info');
      return;
    }
    uploadToS3(file).then(res => {
      const image = res.data;
      if (!image) {
        HelpOther.toast(`${file.name}上传失败，请重试`, 'error');
        return;
      }
      setImgurl(image.url);
    });
  };

  // 服务总开关
  const onChangeFirmSwitch = async (enable) => {
    const params = {
      ...store.activeModel,
      enable,
      firm_id: store.activeModel.id,
      models: store.activeModel?.models?.map(item => {
        return {
          ...item,
          enable,
          update_time: Date.now(),
        }
      })
    };
    const success = await customModelInfo(params);
    if (success) {
      store.setActiveModel(params)
      store.setModelFirmList(params);
    }
  }

  useEffect(() => {
    let {
      protocol,
      api_url,
      apiVersion,
      name,
      model_type,
      id,
      models,
    } = store.activeModel || {};
    if (protocol === 4) {
      // api_url = 'https://brazilsouth-gpt-4o.openai.azure.com/openai/deployments/gpt-4o/chat/completions?api-version=2024-12-01-preview'
      const url = api_url?.split('?');
      api_url = url?.[0];
      if (api_url) {
        const str = api_url?.split('/');
        api_url = str[0] + '//' + str[2];
      }
      apiVersion = url?.[1]?.split('=')?.[1];
    }
    // models 为空则禁用检测按钮
    setDisabled(!models?.length);
    setSecretKey(store.activeModel?.key?.api_key);
    // setSecretKey('ArweDOIfFgrL5yZastayKoEfgHdx3VNpEY4Z4ykrR8oG6os2LQfTJQQJ99ALACZoyfiXJ3w3AAABACOGTfc3');
    setApiUrl(api_url);
    setApiVersion(apiVersion);
    setModelName(store.activeModel?.models?.[0]?.name);
    // setModelName('gpt-4o');
    setImgurl(store.activeModel?.models?.[0]?.icon);
    setFirmSwitch(store.activeModel?.enable);
    // 私有模型 name为Ollama id是预制id 则是Ollama 
    setIsOllama(model_type ===3 && name === 'Ollama' && store.isPreset(id));
  }, [store.activeModel]);

    return (
      <Spin spinning={loading}>
        <div className='w-586px h-73vh flex flex-col pl-20px pr-20px nw-scrollbar overflow-y-auto '>
         <InfiniteScroll
          dataLength={store.modeList?.length}
          loader={null}>
            <div className="my-14px">
            <div >
              <div className="flex items-center justify-between">
                <span className="flex text-16px items-center font-bold">
                  {
                    store.activeModel?.name
                  }
                    <div className='hover:bg-[rgba(0,0,0,0.03)]r'>
                      {
                        store.activeModel?.websites?.official &&  
                        <span
                            className="text-12px text-[#000000B2] font-normal ml-8px hover:text-[#006AFF] whitespace-nowrap cursor-pointer"
                            href={store.activeModel?.websites?.official}
                            onClick={() => {
                              window.open(store.activeModel?.websites?.official, '_blank');
                            }}
                          >
                            产品介绍
                          </span>
                      }
                  </div>
                </span>
                <Switch onClick={onChangeFirmSwitch} disabled={disabled} checked={firmSwitch} className={[ globalStore.isDark ? 'dark-switch' : 'light-switch']} />
              </div>
            </div>
            <Divider className={[globalStore.isDark?  'dark-divider' : '']} />
            {/* API密钥部分 */}
            <div className="mb-20px">
              <label className="block text-14px m-8px ml-0 leading-20px font-bold">API密钥</label>
              <Input.Password
                    placeholder="多个密钥使用逗号分隔（非必填）"
                    className="h-40px"
                    onChange={(e) => setSecretKey(e.target.value.trim())}
                    value={secretKey}
                  />
            </div>
            <div className="mb-20px">
              <label className="block text-14px m-8px ml-0 leading-20px font-bold">API地址</label>
              <Input value={apiUrl} onChange={(e) => setApiUrl(e.target.value.trim())} allowClear className="h-40px" placeholder="请填写标准URL地址或本地IP地址" />
              {
                store.activeModel?.protocol === 1 ? (
                  <div className='text-12px mt-6px mx-12px text-[#7B7E81] flex justify-between'>
                    <span>{updateTipsURL(apiUrl)}</span>
                    <span>/结尾忽略v1版本，#结尾强制使用输入地址</span>
                  </div>
                ) : null
              }
            </div>
            {
              !isOllama && <div className="mb-20px">
                <label className="block text-14px m-8px ml-0 leading-20px font-bold">模型名称</label>
                <Input value={modelName} onChange={(e) => setModelName(e.target.value.trim())} allowClear className="h-40px" placeholder="请输入模型名称" />
              </div>
            }
            {
              (store.activeModel?.protocol === 4 && !isOllama) ? (
                <div className="mb-20px">
                  <label className="block text-14px m-8px ml-0 leading-20px font-bold">API版本</label>
                  <Input value={apiVersion} onChange={(e) => setApiVersion(e.target.value.trim())} allowClear className="h-40px" placeholder="请输入API版本" />
                </div>
              ) : null
            }
            <div className="mb-32px">
                <div
                  className='w-96px h-40px flex items-center font-bold hover:bg-[#e6e6e6] ml-auto justify-center bg-[#f0f0f0] rounded-10px cursor-pointer'
                  onClick={handleCheck}
                  >
                    检测
                </div>
            </div>
            {
              (isOllama && store.activeModel?.models?.length) && <div className='mb-12px text-14px'>
                 <Card
                   title='Ollama'
                   size="small"
                   className={[globalStore.isDark ? 'dark-card' : '']}
                   style={{
                     border: '1px solid rgba(0,0,0,0.1)',
                     backgroundColor: globalStore.isDark ? '#45454E' : '',
                   }}
                 >
                   <div className='flex flex-col'>
                     {
                       store.activeModel?.models.map((item, index) => {
                         return (
                           <div className='flex h-48px justify-between items-center' key={index}>
                             <div className='flex gap-8px'>
                               <Image
                                 preview={false}
                                 src='https://p1.ssl.qhimg.com/t110b9a930130b6f57efcd65b9a.jpg'
                                 fallback={`https://p0.ssl.qhimg.com/t01fa56fdc3fe79f15f.png`} // 404
                                 className="!w-24px !h-24px !object-cover !rounded-8px"
                                 rootClassName="!w-24px !h24px !object-cover !rounded-8px"
                               />
                               {item?.name}
                             </div>
                             <div className='flex gap-32px'>
                               {/* <Switch disabled={!modelInfo?.enable} onClick={() => onChangeModelSwitch(item)} checked={item.enable} className={[globalStore.isDark ? 'dark-switch' : 'light-switch']} /> */}
                             </div>
                           </div>
                         )
                       })
                     }
                   </div>
                 </Card>
               </div>
            }
           {
             !isOllama && <div className="mb-8px">
             <label className="block text-14px m-8px  ml-0 leading-20px font-bold">头像</label>
             {
               imgUrl ?  <div
                 className={[
                   'size-100px rounded-50px vh-center relative',
                 ]}
                 style={{
                   background: `url(${imgUrl}) center center / cover no-repeat`,
                 }}
               >
                 <div
                   onClick={() => {
                     setImgurl('');
                   }}
                   className="absolute -top-5px -right-5px w-20px h-20px rounded-full bg-black bg-opacity-50 vh-center cursor-pointer"
                 >
                   <SVGPureIcon name="x" size={10} iconClass="text-white" />
                 </div>
               </div> :  <Upload
                 multiple
                 accept="image/*"
                 showUploadList={false}
                 className="uploader-without-filelist"
                 customRequest={handleUpload}
               >
                 <div
                   className={[
                     'size-100px vh-center !flex-col mb-8px',
                   ]}
                 >
                   <img src="https://p5.ssl.qhimg.com/t110b9a9301c398eb9e528feb1f.png" alt="" />
                 </div>
               </Upload>
             }
            
           </div>
           }
          </div>
        </InfiniteScroll>
      </div>
      </Spin>
    );
});
export default PrivateForm;